import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-search-selections',
  templateUrl: './search-selections.component.html',
  styleUrls: ['./search-selections.component.scss']
})
export class SearchSelectionsComponent implements OnInit {


  constructor(
    private keycloakService: KeycloakService,
    private appConstants : AppConstants,
    private authService : AuthService
  ) { }

  cancelSelections : boolean = false
  markSelectionsSent : boolean = false
  downloadSelectionNotices : boolean = false
  emailSelectionNotices : boolean = false
  createSelectionLetters : boolean = false
  canCancelComponents : boolean = false
  candeleteSelections : boolean = false

  userInfo: any;
  async ngOnInit() {
     this.isLoading = true;
    if (await this.keycloakService.isLoggedIn()) {
      const user = this.appConstants.userDetails
      this.cancelSelections = await this.authService.checkRoleExist('cancelSelections');
      this.markSelectionsSent = await this.authService.checkRoleExist('markSelectionsSent');
      this.downloadSelectionNotices = await this.authService.checkRoleExist('downloadSelectionNotices');
      this.emailSelectionNotices = await this.authService.checkRoleExist('emailSelectionNotices');
      this.createSelectionLetters = await this.authService.checkRoleExist('createSelectionLetters');
      this.candeleteSelections = await this.authService.checkRoleExist('deleteSelections');
      this.canCancelComponents = await this.authService.checkRoleExist('cancelComponents');
      this.userInfo = user;
    }
    this.sendSearchSelectionsInfo();
  }

  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }
 
  searchSelectionsInfo: any = {}
  sendSearchSelectionsInfo() {
    let details = {
      endPoints: this.appConstants.endPoints,
      userInfo: this.userInfo,
      permissions: {
        cancelSelections : this.cancelSelections,
        markSelectionsSent : this.markSelectionsSent,
        downloadSelectionNotices : this.downloadSelectionNotices,
        emailSelectionNotices : this.emailSelectionNotices,
        createSelectionLetters : this.createSelectionLetters,
        candeleteSelections : this.candeleteSelections,
        canCancelComponents : this.canCancelComponents
      }
    }
    this.searchSelectionsInfo = {...{}, ...details}

      this.getToken();
      setTimeout(() => {
        this.getToken();
      }, 1000);
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }


}
